export default [
  'clickConvertToTemplate',
  'clickDownloadTemplate',
  'clickImportType',
  'mappingComplete',
  'startImport',
  'uploadFileComplete',
  'submitImport2'
]
